module.exports = __webpack_public_path__ + "static/img/robot-jicheng.42729ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot-jicheng.png
// module id = F1iE
// module chunks = 1